import { isCanlan } from './customer-name'
import { isSportNinjaUser } from './isSportNinjaUser'

/**
 * Emails allowed to impersonate on the Canlan tenant only. These are Canlan
 * staff who support their own users; they are NOT SportNinja staff, so they
 * must not inherit anything else `isSportNinjaUser` gates (feature flags, etc).
 */
export const CANLAN_IMPERSONATION_EMAILS = [
  'scampbell@canlansports.com',
  'kmatthews@canlansports.com',
]

/**
 * Checks if the given email is allowed to impersonate another user.
 *
 * Any @sportninja.com address may impersonate on every tenant. On the Canlan
 * tenant only, the two allow-listed Canlan staff addresses may as well.
 */
export const canImpersonate = (email?: string | null): boolean => {
  if (!email) return false
  if (isSportNinjaUser(email)) return true
  if (!isCanlan) return false
  return CANLAN_IMPERSONATION_EMAILS.includes(email.trim().toLowerCase())
}

export default canImpersonate
